import React, { useEffect } from 'react';
import { useGlobal } from 'reactn';
import StaffProfile from './staff-profile';
import Learner from '../../../users/learner/Learner';
import { withRouter } from '../../../../util/router-compatibility';
import { getUserIdFromURL } from '../../../../util/Helpers';
import { getRouteSearchString } from '../../../../v2/services/utilty';

const STAFF_PROFILE_QUERY = '?type=staff';

const Profile = (props) => {
  const [global, setGlobal] = useGlobal();
  const { history, location } = props;

  const search = getRouteSearchString(location);
  const searchParams = new URLSearchParams(search);
  const type = searchParams.get('type');
  const personId = getUserIdFromURL('users') || props.params?.id;
  const isStaffProfile = type === 'staff';

  useEffect(() => {
    if (isStaffProfile && personId && !global.staffProfileID) {
      setGlobal({ staffProfileID: personId });
    }

    if (isStaffProfile && personId && history?.replace) {
      const staffPath = `/users/${personId}${STAFF_PROFILE_QUERY}`;
      const pathname = location?.pathname;
      if (pathname === `/users/${personId}` && search !== STAFF_PROFILE_QUERY) {
        history.replace(staffPath);
      }
    }
  }, [
    isStaffProfile,
    personId,
    search,
    global.staffProfileID,
    setGlobal,
    history,
    location?.pathname,
  ]);

  return (
    <>
      {isStaffProfile ? 
        <StaffProfile data-testid="staff-profile-component" {...props} history={props.history} />
        : 
        <Learner data-testid="learner-component" />
      }
    </>
  );
}

export default withRouter(Profile);